import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { If, Then, Else } from '../../../sharedLegacy/components'
import { ScheduleTimerComponent } from '../../../Webinar/components'

import './WaitingRoomCountdownComponent.scss'

const WaitingRoomCountdownComponent = (props) => {
  const {
    webinarTimeEpoch,
    isHolding,
    onLiveCountdownZero,
    isWebinarTimeInThePast,
  } = props

  return (
    <div className="waiting-room-countdown-component">
      <If condition={isHolding || isWebinarTimeInThePast}>
        <Then>
          <div className="starting-in">
            <FormattedMessage defaultMessage="Hold on" />
          </div>
          <div className="big-message">
            {isHolding ? (
              <FormattedMessage defaultMessage="Continuing shortly" />
            ) : (
              <FormattedMessage defaultMessage="Starting shortly" />
            )}
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            ...
          </div>
        </Then>
        <Else>
          <div className="starting-in">
            <FormattedMessage defaultMessage="Starting in" />
          </div>
          <ScheduleTimerComponent
            startTimeEpoch={webinarTimeEpoch}
            renderOnlyTimer
            onLiveCountdownZero={onLiveCountdownZero}
          />
        </Else>
      </If>
    </div>
  )
}

WaitingRoomCountdownComponent.propTypes = {
  webinarTimeEpoch: PropTypes.number,
  isHolding: PropTypes.bool,
  isWebinarTimeInThePast: PropTypes.bool,
  onLiveCountdownZero: PropTypes.func,
}

export default WaitingRoomCountdownComponent
